import Home from '../components/home/Home';

export default [
  {
    path: '/',
    getComponent(nextState, callback) {
      callback(null, Home);
    },
  },
];



/** WEBPACK FOOTER **
 ** ./src/app/modules/floorplan/routes/index.js
 **/